module.exports = __webpack_public_path__ + "static/agatawork8-4ab8e8fbb1f56ad75480ce2b3331bf07.jpg";